import ConduitEvents from '@tagboard/lib-events';

let instance;

const ConduitEventsService = {
  async init(userId) {
    instance = await ConduitEvents.initialize({
      pusherKey: process.env.PUSHER_KEY,
      pusherCluster: process.env.PUSHER_CLUSTER,
      pusherAuthApi: process.env.CONDUIT_PUSHER_AUTH_API,
      userId,
    });
    return instance;
  },

  /**
   * @param {string} eventName - Format: `{source}.{action/category}.{eventName}`
   * @param {object} eventData - The event data payload
   * @param {object} [eventContext] - Additional event context data
   * @returns {*}
   */
  // eslint-disable-next-line max-len
  track: (eventName, eventData, eventContext) => instance?.track(eventName, eventData, eventContext),
};

export default ConduitEventsService;
